<div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  <div class="bg-white p-6 rounded-lg w-full max-w-md relative">

    <button
      class="absolute top-2 right-2 text-xl"
      (click)="close()"
      type="button"
    >
      ×
    </button>

    <h2 class="text-xl font-bold mb-4">Ask a Question</h2>

    <form
      [formGroup]="questionForm"
      (ngSubmit)="submit()"
    >
      <!-- <input
        type="text"
        placeholder="Your Name (optional)"
        formControlName="name"
        class="w-full border p-2 rounded mb-3"
      />

      <input
        type="email"
        placeholder="Email (optional)"
        formControlName="email"
        class="w-full border p-2 rounded mb-3"
      /> -->

      <textarea
        rows="4"
        placeholder="Write your question..."
        formControlName="question"
        class="w-full border p-2 rounded mb-3"
      ></textarea>

      <button
        class="bg-customPink bg-purple-500 text-white px-4 py-2 rounded w-full"
        [disabled]="questionForm.invalid"
        type="submit"
      >
        Submit Question
      </button>
    </form>

  </div>
</div>
